import React from "react";
import { Truck } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const FreeShippingBar = ({ dark = false }) => {
  const { cart } = useCart();
  const fs = cart.free_shipping;
  if (!fs?.enabled || cart.items.length === 0) return null;
  const progress = Math.min(100, Math.round(((fs.threshold - fs.remaining) / fs.threshold) * 100));
  const text = dark ? "text-cream" : "text-forest";
  const muted = dark ? "text-cream/60" : "text-mutedgreen";
  return (
    <div data-testid="free-shipping-bar" className={`rounded-xl px-4 py-3 border ${dark ? "border-cream/15 bg-cream/5" : "border-forest/10 bg-[#E8F0EA]/60"}`}>
      <p className={`flex items-center gap-2 text-xs font-semibold ${text}`}>
        <Truck size={14} className="text-gold shrink-0" />
        {fs.unlocked ? <span data-testid="free-shipping-unlocked">You've unlocked free shipping!</span> : <span data-testid="free-shipping-remaining">Add ₹{fs.remaining} more for free shipping</span>}
      </p>
      <div className={`mt-2 h-1.5 rounded-full overflow-hidden ${dark ? "bg-cream/15" : "bg-forest/10"}`}>
        <div className="h-full bg-gold rounded-full transition-all duration-700" style={{ width: `${progress}%` }} />
      </div>
      {!fs.unlocked && <p className={`text-[10px] mt-1.5 ${muted}`}>{fs.text}</p>}
    </div>
  );
};
